import { computed } from 'mobx'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { ActivationLifecycle } from '@/infra/activation'
import type { SubmittedJob } from '@/features/jobs/details/SubmittedJob'
import type {
  EnsureSection7216AcceptanceFn,
  EnsureSection7216AcceptanceResult,
} from '@/features/account'
import { firstValueFrom, type Observable } from 'rxjs'

export class Section7216AcceptanceViewModel implements ActivationLifecycle {
  /**
   * Manages the ViewModel's lifecycle, ensuring proper cleanup and activation.
   */
  private readonly _lifecycle = new LifecycleTracker()

  constructor(
    private readonly _job: SubmittedJob,
    private readonly _spouseRequired$: Observable<boolean>,
    private readonly _ensureSection7216Accepted: EnsureSection7216AcceptanceFn,
  ) {}

  @computed
  get isAcceptanceRequired(): boolean {
    if (this._job.status === 'Closed') {
      return false
    }

    return this._job.workspace.config.section7216.enabled
  }

  async ensureAcceptance(
    signal?: AbortSignal,
  ): Promise<EnsureSection7216AcceptanceResult> {
    if (!this.isAcceptanceRequired) {
      return 'Aborted'
    }

    const spouseRequired = await firstValueFrom(this._spouseRequired$)
    return await this._ensureSection7216Accepted({
      isSpouseRequired: spouseRequired,
      signal,
    })
  }

  activate() {
    this._lifecycle.activate()
  }

  deactivate() {
    this._lifecycle.deactivate()
  }
}
